module.exports = __webpack_public_path__ + "img/PL09184.388ca304.svg";